// extracted by mini-css-extract-plugin
module.exports = {"contactLabel":"styles_contactLabel__2WbRc","addComplaint":"styles_addComplaint__3Uyza"};